import {useCallback, useEffect, useRef} from 'react';

type Props = {
    className?: string;
    audioData: Uint8Array;
    frameSizes: {width: number, height: number};
    fillStyle?: string
};

const BAR_WIDTH = 4;

export const DataVisualization: React.FC<Props> = ({className, audioData, frameSizes, fillStyle}) => {
    const canvasRef = useRef(null);
    const smoothed = useRef<number[]>([]);

    const draw = useCallback(() => {
        const currentCanvas = canvasRef.current;
        const {width, height} = currentCanvas;
        const context = currentCanvas.getContext('2d');

        const barWidth = width / audioData.length;
        let barHeight;
        let x = 0;

        context.clearRect(0, 0, width, height);
        if (smoothed.current.length !== audioData.length) {
            smoothed.current = new Array(audioData.length).fill(0);
        }

        for (let i = 0; i < audioData.length; i++) {
            const centered = Math.abs(audioData[i] - 128);
            let scaled = (centered / 128) * 10;
            scaled = Math.min(scaled, 1);

            const targetHeight = scaled * height;

            smoothed.current[i] = smoothed.current[i] * 0.8 + targetHeight * 0.2;
            barHeight = smoothed.current[i];

            context.fillStyle = fillStyle || `rgb(0, ${Math.floor(barHeight)}, 255)`;
            context.fillRect(x, height - barHeight, barWidth, barHeight);
            x += barWidth + BAR_WIDTH;
        }
    }, [audioData, fillStyle]);

    useEffect(draw, [draw]);

    return (
        <div className={className}>
            <canvas ref={canvasRef} width={frameSizes.width} height={frameSizes.height} />
        </div>
    );
};